import React from "react";
import {AppBar, IconButton, styled, Tab, Tabs, Toolbar, Typography} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";



const EficsHeader = ({children, tabs, buttons, onMenuClick, showMenuButton = true}) => {
    return <AppBar position="static">
        <Toolbar variant="regular">
            {showMenuButton && (
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{mr: 2}}
                    className="NavigationMenuButton"
                    onClick={onMenuClick}
                >
                    <MenuIcon/>
                </IconButton>
            )}
            <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                {children}
            </Typography>
            {buttons ? buttons : ""}
            {/*<Button color="inherit">Login</Button>*/}
        </Toolbar>
        {tabs ? tabs : ""}

    </AppBar>
}
export default EficsHeader